import React, { Component } from 'react';
import { Button, Modal, FormControl, FormGroup, ControlLabel, Checkbox } from 'react-bootstrap';
import { connect } from 'react-redux';

import OverlayLoader from '../components/overlayLoader';
import { showModalMessage } from '../store/modalsSlice';

import * as trialSettingsActions from '../store/trialSettingsSlice';
import { unwrapResult } from '@reduxjs/toolkit';
import { trialSettingsSelectors } from '../store/trialSettingsSlice';

class TrialGeneralSettingsEditDialog extends Component {
	initState = {
		minAllowedViewerVersion: '',
		onceAYear: false,
	};

	constructor(props) {
		super(props);
		this.handleClose = this.props.onClose;

		this.state = this.initState;

		this.onShow = this.onShow.bind(this);
		this.onClose = this.onClose.bind(this);
		this.onSubmit = this.onSubmit.bind(this);
	}

	onShow() {
		const selectedData = {
			minAllowedViewerVersion: this.props.selectedMinAllowedViewerVersion,
			onceAYear: this.props.selectedOnceAYear,
		};
		this.setState(selectedData);
		this.initState = selectedData;
	}

	onClose() {
		this.handleClose();
	}

	onSubmit() {
		this.onClose();

		return this.props
			.editTrialSettings({
				id: 1,
				minAllowedViewerVersion: this.state.minAllowedViewerVersion,
				onceAYear: this.state.onceAYear,
			})
			.then(unwrapResult)
			.catch((e) => {
				console.log(e);
			});
	}

	isLoading() {
		return false;
	}
	isMatchedRegExp() {
		return new RegExp('^([0-9]+\\.){2}([0-9]+)$').test(this.state.minAllowedViewerVersion);
	}
	isSubmitButtonDisabled() {
		return (
			this.isLoading() ||
			!this.state.minAllowedViewerVersion.length ||
			!this.isMatchedRegExp() ||
			!this.isTouched()
		);
	}
	isTouched() {
		return !(
			this.initState.minAllowedViewerVersion === this.state.minAllowedViewerVersion &&
			this.initState.onceAYear === this.state.onceAYear
		);
	}

	renderminAllowedViewerVersionFormControl() {
		return (
			<FormGroup controlId='fcminAllowedViewerVersion'>
				<ControlLabel>Min. allowed viewer version</ControlLabel>

				<FormControl
					onChange={(e) => {
						this.setState({ minAllowedViewerVersion: e.target.value });
					}}
					value={this.state.minAllowedViewerVersion}
					type='text'
				/>
				{!this.isMatchedRegExp() && (
					<FormControl.Static className='text-danger'>Wrong format</FormControl.Static>
				)}
			</FormGroup>
		);
	}

	renderOnceAYearCheckbox() {
		return (
			<Checkbox
				onChange={() => {
					this.setState((state) => ({
						onceAYear: !state.onceAYear,
					}));
				}}
				checked={this.state.onceAYear}>
				<b>Once a year</b>
			</Checkbox>
		);
	}

	render() {
		return (
			<Modal
				bsSize='small'
				show={this.props.show}
				onShow={this.onShow}
				onHide={this.onClose}
				backdrop='static'>
				<Modal.Header>
					<Modal.Title>Edit general settings</Modal.Title>
				</Modal.Header>
				<Modal.Body>
					<OverlayLoader active={this.isLoading()} text={'...'}>
						{this.renderminAllowedViewerVersionFormControl()}
						{this.renderOnceAYearCheckbox()}
					</OverlayLoader>
				</Modal.Body>
				<Modal.Footer>
					<Button onClick={this.onSubmit} disabled={this.isSubmitButtonDisabled()}>
						Save
					</Button>
					<Button onClick={this.onClose}>Close</Button>
				</Modal.Footer>
			</Modal>
		);
	}
}

const mapStateToProps = (state) => ({
	selectedOnceAYear: trialSettingsSelectors.selectOnceAYear(state),
	selectedMinAllowedViewerVersion: trialSettingsSelectors.selectMinAllowedViewerVersion(state),
});

const actionCreators = {
	editTrialSettings: trialSettingsActions.editTrialSettings,

	showModalMessage: (title, text) => showModalMessage({ title, text }),
};

export default connect(mapStateToProps, actionCreators)(TrialGeneralSettingsEditDialog);



// WEBPACK FOOTER //
// ./src/containers/trialGeneralSettingsEditDialog.js